<template>
  <div>
    <h3 class="text-lg leading-6 font-medium text-gray-900">Sms Campaign Statistics</h3>
    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <BaseCard>
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Total Recipients</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ recipientsCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard>
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Unique Recipients</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ phoneNumbersCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard>
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Total Sent</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ phoneNumbersSentCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
      <BaseCard>
        <BaseCardBody>
          <dt class="text-sm font-medium text-gray-500 truncate">Total Failed</dt>
          <dd class="mt-1 text-3xl font-semibold text-gray-900">
            {{ phoneNumbersFailedCount }}
          </dd>
        </BaseCardBody>
      </BaseCard>
    </dl>
  </div>
</template>

<script>
import Numbro from '@/utils/numbro';

export default {
  props: {
    smsCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    recipientsCount() {
      return Numbro(this.smsCampaign.recipients_count || 0).format({ thousandSeparated: true });
    },
    phoneNumbersCount() {
      return Numbro(this.smsCampaign.phone_numbers_count || 0).format({ thousandSeparated: true });
    },
    phoneNumbersSentCount() {
      return Numbro(this.smsCampaign.phone_numbers_sent_count || 0).format({
        thousandSeparated: true,
      });
    },
    phoneNumbersFailedCount() {
      return Numbro(this.smsCampaign.phone_numbers_failed_count || 0).format({
        thousandSeparated: true,
      });
    },
  },
};
</script>
